import { Stack, styled } from "@mui/material";

export const EditCurrencyExchangeRateWrapper = styled(Stack)(({ theme }) => {
    return {
        gap: "var(--flex-gap)",
        padding: "var(--basic-padding)",
        backgroundColor: "var(--light-color)",
        borderRadius: "16px",
        overflow: "hidden",
        "& form": {
            display: "flex",
            flexDirection: "column",
            gap: "var(--flex-gap)",
        },
        "& fieldset": {
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
        },
        "& .unit-exchange-rate-box": {
            borderRadius: "8px",
            backgroundColor: "var(--dark-grey-color)",
            padding: "calc(var(--basic-padding)/2)"
        }
    }
})